"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyMonitorIntegrationType = void 0;
var NotifyMonitorIntegrationType;
(function (NotifyMonitorIntegrationType) {
    NotifyMonitorIntegrationType["INCIDENT"] = "INCIDENT";
    NotifyMonitorIntegrationType["SSL_CERTIFICATE_EXPIRATION"] = "SSL_CERTIFICATE_EXPIRATION";
    NotifyMonitorIntegrationType["DOMAIN_NAME_EXPIRATION"] = "DOMAIN_NAME_EXPIRATION";
})(NotifyMonitorIntegrationType = exports.NotifyMonitorIntegrationType || (exports.NotifyMonitorIntegrationType = {}));
